import { observer } from 'mobx-react';
import { currentUserStore } from '../../../../CurrentUserStore';
import { emptyFragment } from '../../../../EmptyFragment';
import { findLink } from '../../../../LinkyLinky';
import { translation, TranslationsContext } from '../../../../Translations';
import CountStore from '../../CountStore';
import { Segment } from '../../Segment';
import SegmentTab from './SegmentTab';

interface Props {
  segment: Segment;
  participantsCount: CountStore;
  groupsCount: CountStore;
}

/**
 * The page's only section switcher. Groups appears only for admins who can
 * see groups, as on the current page.
 */
function SegmentedControl({ segment, participantsCount, groupsCount }: Props) {
  // Read before the Consumer callback so observer tracks it.
  const groupsTab = findLink('user-groups', currentUserStore.links)
    .map(() => (
      <SegmentTab segment="groups" current={segment} label="Groups" countStore={groupsCount} />
    ))
    .getOrElse(emptyFragment);

  return (
    <TranslationsContext.Consumer>
      {(ts) => (
        <nav
          aria-label={translation('People sections')(ts)}
          className="inline-flex rounded-lg bg-muted p-1"
        >
          <SegmentTab
            segment="participants"
            current={segment}
            label="Participants"
            countStore={participantsCount}
          />
          {groupsTab}
        </nav>
      )}
    </TranslationsContext.Consumer>
  );
}

export default observer(SegmentedControl);
